import { toastr } from "react-redux-toastr";
import { EventTypeDetails } from "../../entities/eventTypeDetails";
import { addEventType, getPartnerEventTypes, updatePartnerEventType, getPartnerEventTypeDetail } from "../../services/partnerEventTypeServices";
import constant from "../../util/constant";
import eventTypeConstant from "../../util/eventTypeConstant";
import {
  START_LOADER,
  STOP_LOADER,
  PARTNER_EVENT_TYPE_API_REQUEST,
  PARTNER_EVENT_TYPE_API_END,
  ADD_EVENT_TYPE_SUCCESS,
  ADD_EVENT_TYPE_FAILURE,
  GET_PARTNER_EVENT_TYPES_SUCCESS,
  GET_PARTNER_EVENT_TYPES_FAILURE,
  UPDATE_EVENT_TYPE_SUCCESS,
  UPDATE_EVENT_TYPE_FAILURE,
  GET_PARTNER_EVENT_TYPE_DETAIL_SUCCESS,
  GET_PARTNER_EVENT_TYPE_DETAIL_FAILURE
} from "../actionTypes";

const { EVENT_TYPE_API_TYPES } = eventTypeConstant;
const { ERROR_MESSAGES } = constant;

export const addEventTypeAction = param => async ( dispatch ) => {
  try {
    dispatch( { type: START_LOADER } );
    dispatch( {
      type: PARTNER_EVENT_TYPE_API_REQUEST,
      payload: EVENT_TYPE_API_TYPES.ADD_EVENT_TYPE,
    } );

    const response = await addEventType( param );

    dispatch( { type: ADD_EVENT_TYPE_SUCCESS, payload: response.data } );
    dispatch( { type: STOP_LOADER } );
  }
  catch ( error ) {
    const err = Object.values( error?.data?.error || {} ) || "";

    dispatch( { type: STOP_LOADER } );
    dispatch( { type: ADD_EVENT_TYPE_FAILURE, payload: error } );

    if( err[ 0 ] ) {
      toastr.error( err[ 0 ] );
    }
    else {
      toastr.error( error.data.message );
    }
  }
  finally {
    dispatch( {
      type: PARTNER_EVENT_TYPE_API_END,
    } );
  }
};

export const getPartnerEventTypesAction = param => async ( dispatch ) => {
  try {
    dispatch( { type: START_LOADER } );
    dispatch( {
      type: PARTNER_EVENT_TYPE_API_REQUEST,
      payload: EVENT_TYPE_API_TYPES.GET_PARTNER_EVENT_TYPES,
    } );

    const response = await getPartnerEventTypes( param );
    const dataList = response.data.eventTypeData.map(
      item => new EventTypeDetails( item )
    );

    dispatch( {
      type: GET_PARTNER_EVENT_TYPES_SUCCESS,
      payload: { dataList, meta: response.data.meta },
    } );
    dispatch( { type: STOP_LOADER } );
  }
  catch ( error ) {
    dispatch( { type: STOP_LOADER } );
    dispatch( {
      type: GET_PARTNER_EVENT_TYPES_FAILURE,
      payload: error?.data?.message || ERROR_MESSAGES.EXCEPTION_ERROR,
    } );
    toastr.error( error?.data?.message || ERROR_MESSAGES.EXCEPTION_ERROR );
  }
  finally {
    dispatch( {
      type: PARTNER_EVENT_TYPE_API_END,
    } );
  }
};

export const updatePartnerEventTypeAction = param => async ( dispatch ) => {
  try {
    dispatch( { type: START_LOADER } );
    dispatch( {
      type: PARTNER_EVENT_TYPE_API_REQUEST,
      payload: EVENT_TYPE_API_TYPES.UPDATE_PARTNER_EVENT_TYPE,
    } );

    const response = await updatePartnerEventType( param );

    dispatch( { type: UPDATE_EVENT_TYPE_SUCCESS, payload: response.data } );
    dispatch( { type: STOP_LOADER } );
  }
  catch ( error ) {
    const err = Object.values( error?.data?.error || {} ) || "";

    dispatch( { type: STOP_LOADER } );
    dispatch( { type: UPDATE_EVENT_TYPE_FAILURE, payload: error } );

    if( err[ 0 ] ) {
      toastr.error( err[ 0 ] );
    }
    else {
      toastr.error( error.data.message );
    }
  }
  finally {
    dispatch( {
      type: PARTNER_EVENT_TYPE_API_END,
    } );
  }
};

export const getPartnerEventTypeDetailAction = param => async ( dispatch ) => {
  try {
    dispatch( { type: START_LOADER } );
    dispatch( {
      type: PARTNER_EVENT_TYPE_API_REQUEST,
      payload: EVENT_TYPE_API_TYPES.GET_PARTNER_EVENT_TYPE_DETAIL,
    } );

    const response = await getPartnerEventTypeDetail( param );
    const newResponse = new EventTypeDetails( response.data );

    dispatch( {
      type: GET_PARTNER_EVENT_TYPE_DETAIL_SUCCESS,
      payload: newResponse,
    } );
    dispatch( { type: STOP_LOADER } );
  }
  catch ( error ) {
    dispatch( { type: STOP_LOADER } );
    dispatch( {
      type: GET_PARTNER_EVENT_TYPE_DETAIL_FAILURE,
      payload: error?.data?.message || ERROR_MESSAGES.EXCEPTION_ERROR,
    } );
    toastr.error( error?.data?.message || ERROR_MESSAGES.EXCEPTION_ERROR );
  }
  finally {
    dispatch( {
      type: PARTNER_EVENT_TYPE_API_END,
    } );
  }
};
